import { ReactComponent } from "/builds/mb/front/src/app/assets/images/redExclamationMark.svg?react";
import url from "/builds/mb/front/src/app/assets/images/redExclamationMark.svg?url";
export { ReactComponent };
export default url;
